export default {
  err_already_invited_title: 'Ya invitado',
  err_already_invited_message: 'Ya existe una invitación pendiente para esta clínica.',
  err_invitation_existing_collaborator_title: 'Invitación enviada a una colaboradora existente',
  err_invitation_existing_collaborator_message: 'La clínica a la que intentas invitar ya está registrada en la plataforma. Intentalo de nuevo con el buscador de clínicas.',
};
